import { styled } from '@mui/material/styles';

export const ModalFooter = styled('div')({
    padding: '0.5rem 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '0.8rem',
});
